import accountApi from 'src/component/app/account/AccountApi';
import dspApi from 'src/component/app/dsp/DspApi';
import {
    AccountBean,
    ClusterKeyValue,
    DspBean,
    IabCategoryBean,
    ItemResponseAccountBeanObject,
    ItemResponseDspBeanObject,
    LanguageBean,
    ListResponseAccountBean,
    ListResponseDspBean,
    ListResponsePublisherBean,
    ItemResponsePublisherBeanObject,
    PublisherBean,
    ListResponseHouseAdSizeBean,
    HouseAdSizeBean,
    ItemResponseHouseAdSizeBeanObject,
    TimeZoneBean,
    CountryBean,
    DictionaryOption
} from '../api/api';
import publisherApi from 'src/component/app/publisher/PublisherApi';
import dictionariesApi from './DictionariesApi';
import houseAdSizeApi from 'src/component/app/houseAdSize/HouseAdSizeApi';
import dealApi from 'src/component/app/deal/DealApi';
import reportApi from 'src/component/app/reports/ReportApi';

export interface LoadInfo {
    iabCategories?: Array<IabCategoryBean>,
    accounts?: Array<AccountBean>,
    dspList?: Array<DspBean>,
    languages?: Array<LanguageBean>,
    publishers?: PublisherBean[]
    dealTypes?: any
    dealStatus?: any
    deviceTypes?: any
    targetDeviceTypes?: DictionaryOption[]
    targetOperatingSystems?: DictionaryOption[]
    mediaTypes? : any
    adSizes? : any
    countries?: Array<CountryBean>
    clusterEndpoints?: Array<ClusterKeyValue>
    publisherReportColumns?: { columns: string[], groupBy: string[] }
    dspReportColumns?: { columns: string[], groupBy: string[] }

}

export enum FormDataType {
    IabCategories,
    Accounts,
    Publishers,
    Languages,
    DspList,
    AdSizeList,
    TimeZones,
    DealTypes,
    DealStatus,
    DeviceTypes,
    TargetDeviceTypes,
    TargetOperatingSystems,
    MediaTypes,
    AdSizes,
    Countries,
    ClusterEndpoints,
    PublisherReportColumns,
    DspReportColumns,
}

export function formDataLoader(...dictionaries: FormDataType[]): Promise<LoadInfo> {
    const promises: Promise<Partial<LoadInfo>>[] = [];
    for (let dictionary of dictionaries) {
        switch (dictionary) {
            case FormDataType.Publishers:
                promises.push(
                    publisherApi
                        .all()
                        .then((itemResponsePublisherBeanObject: ListResponsePublisherBean) => {
                            const array = itemResponsePublisherBeanObject.data as Array<ItemResponsePublisherBeanObject>;
                            const publishers: PublisherBean[] = array.map(item => item.data as PublisherBean);
                            return { publishers };
                        })
                );
                break;
            case FormDataType.DealTypes:
                promises.push(
                    dealApi
                        .getAllDealTypes()
                        .then((itemResponsePublisherBeanObject: any) => {
                            const array = itemResponsePublisherBeanObject as Array<ItemResponsePublisherBeanObject>;
                            const dealTypes: PublisherBean[] = array.map(item => item as PublisherBean);
                            return { dealTypes };
                        })
                );
                break;
                 case FormDataType.DeviceTypes:
                promises.push(
                    dealApi
                        .getAllDeviceTypes()
                        .then((itemResponsePublisherBeanObject: any) => {
                            const array = itemResponsePublisherBeanObject as Array<ItemResponsePublisherBeanObject>;
                            const deviceTypes: PublisherBean[] = array.map(item => item as PublisherBean);
                            return { deviceTypes };
                        })
                );
                break;
            case FormDataType.TargetDeviceTypes:
                promises.push(
                    dictionariesApi
                        .deviceTypeList()
                        .then((targetDeviceTypes: DictionaryOption[]) => ({ targetDeviceTypes }))
                );
                break;
            case FormDataType.TargetOperatingSystems:
                promises.push(
                    dictionariesApi
                        .operatingSystems()
                        .then((targetOperatingSystems: DictionaryOption[]) => ({ targetOperatingSystems }))
                );
                break;
                 case FormDataType.MediaTypes:
                promises.push(
                    dealApi
                        .getAllMediaTypes()
                        .then((itemResponsePublisherBeanObject: any) => {
                            const array = itemResponsePublisherBeanObject as Array<ItemResponsePublisherBeanObject>;
                            const mediaTypes: PublisherBean[] = array.map(item => item as PublisherBean);
                            return { mediaTypes };
                        })
                );
                break;
                 case FormDataType.AdSizes:
                promises.push(
                    dealApi
                        .getAllAdSizes()
                        .then((itemResponsePublisherBeanObject: any) => {
                            const array : any = itemResponsePublisherBeanObject as Array<ItemResponsePublisherBeanObject>;
                            const adSizes: PublisherBean[] = array?.data?.map(item => item as PublisherBean);
                            return { adSizes };
                        })
                );
                break;
            case FormDataType.DealStatus:
                promises.push(
                    dealApi
                        .getAllDealStatus()
                        .then((itemResponsePublisherBeanObject: any) => {
                            const array = itemResponsePublisherBeanObject as Array<ItemResponsePublisherBeanObject>;
                            const dealStatus: PublisherBean[] = array.map(item => item as PublisherBean);
                            return { dealStatus };
                        })
                );
                break;
            case FormDataType.Accounts:
                promises.push(
                    accountApi
                        .all()
                        .then((itemResponseAccountBeanObject: ListResponseAccountBean) => {
                            const array = itemResponseAccountBeanObject.data as Array<ItemResponseAccountBeanObject>;
                            const accounts: AccountBean[] = array.map(item => item.data as AccountBean);
                            return { accounts };
                        })
                );
                break;
            case FormDataType.TimeZones:
                promises.push(
                    dictionariesApi.timezones()
                        .then((timezones: Array<TimeZoneBean>) => ({ timezones } as Partial<LoadInfo>))
                );
                break;
            case FormDataType.Languages:
                promises.push(
                    dictionariesApi.languages()
                        .then((languages: Array<LanguageBean>) => ({ languages }))
                );
                break;
            case FormDataType.DspList:
                promises.push(
                    dspApi
                        .all()
                        .then((itemResponseDspBeanObject: ListResponseDspBean) => {
                            const array = itemResponseDspBeanObject.data as Array<ItemResponseDspBeanObject>;
                            const dspList: DspBean[] = array.map(item => item.data as DspBean);
                            return { dspList };
                        })
                );
                break;
            case FormDataType.IabCategories:
                promises.push(
                    dictionariesApi.iabCategories()
                        .then((iabCategories: Array<IabCategoryBean>) => ({ iabCategories }))
                );
                break;
            case FormDataType.Countries:
                promises.push(
                    dictionariesApi.countries()
                        .then((countries: Array<CountryBean>) => ({ countries }))
                );
                break;
            case FormDataType.AdSizeList:
                promises.push(
                    houseAdSizeApi
                        .all()
                        .then((itemResponseHouseAdSizeBeanObject: ListResponseHouseAdSizeBean) => {
                            const array = itemResponseHouseAdSizeBeanObject.data as Array<ItemResponseHouseAdSizeBeanObject>;
                            const adSizeList: HouseAdSizeBean[] = array.map(item => item.data as HouseAdSizeBean);
                            return { adSizeList } as Partial<LoadInfo>;
                        })
                );
                break;
            case FormDataType.ClusterEndpoints:
                promises.push(
                    dspApi.getClusterEndpoints()
                        .then((clusterEndpoints: Array<ClusterKeyValue>) => ({ clusterEndpoints }))
                        .catch((err) => {
                            console.error('Failed to load cluster endpoints:', err)
                            return {};
                        })
                );
                break;
            case FormDataType.PublisherReportColumns:
                promises.push(
                    reportApi
                        .getPublisherReportColumns()
                        .then((publisherReportColumns: { columns: string[], groupBy: string[] }) => ({ publisherReportColumns }))
                        .catch(() => ({}))
                );
                break;
            case FormDataType.DspReportColumns:
                promises.push(
                    reportApi
                        .getDspReportColumns()
                        .then((dspReportColumns: { columns: string[], groupBy: string[] }) => ({ dspReportColumns }))
                        .catch(() => ({}))
                );
                break;
        }
    }
    return Promise.all(promises).then(results => Object.assign({}, ...results) as LoadInfo);
}
